import { render, staticRenderFns } from "./MatchingQuestionScore.vue?vue&type=template&id=16a76795&scoped=true"
import script from "./MatchingQuestionScore.vue?vue&type=script&lang=js"
export * from "./MatchingQuestionScore.vue?vue&type=script&lang=js"
import style0 from "./MatchingQuestionScore.vue?vue&type=style&index=0&id=16a76795&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16a76795",
  null
  
)

export default component.exports